export interface SessionEntry {
    previousAssetId?: number;
    playbackSource?: string;
    wasViewed?: boolean;
    prevPosition?: number;
}

export default {} as Record<string, SessionEntry>;
